export const SLIDES = [
	{
		img: '/img/dashboard01@2x.png',
		heading: 'Frontend Web Developer',
		desc: 'Short project description goes here To explain what the project is all about.',
		link: '/',
	},
	{
		img: '/img/dashboard02@2x.png',
		heading: 'Project Title',
		desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do.',
		link: '/',
	},
	{
		img: '/img/dashboard03@2x.png',
		heading: 'Last Case Study',
		desc: 'Short project description goes here To explain what the project is all about.',
		link: '/',
	},
]
